// extracted by mini-css-extract-plugin
export default {"controls":"BaseFormControls_controls__xv6Vk"};